module.exports = __webpack_public_path__ + "img/default.98f85949.png";